import mainRoute from '@input-web/modules/main/views/main/main.route';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

const loginRoute = createRoute({
  component: lazyRouteComponent(() => import('./login.view')),
  getParentRoute: () => mainRoute,
  path: '/login',
});

export default loginRoute;
